import styled from "styled-components";
import ArrowDown from '../../../assets/icons/icon-arrow-down-circle-gray.png';
import { theme } from "../../../styles/theme";

export const Container = styled.div`
    padding: 16px;
    min-width: 20.625rem;
    max-width: 20.625rem;
    min-height: 20.625rem;
    max-height: 20.625rem;
   
    gap: 24px;
    display: flex;
    flex-direction: column;
    
    border-radius: 16px;
    background-color: #F8F8F9; 

    >div:nth-of-type(1){
        height: auto;
        min-height: 48px;

        margin: 0;
        display: flex;
        align-items: center;

        border-radius: 10rem;

        @media (max-width: 900px) {
            width: 100%;
        }
    }

    >div:nth-of-type(2){
        border: none;
        background-color: transparent;

        >div:nth-of-type(1){
            border-radius: 0.5rem;

            >button:nth-of-type(1){
                :hover{
                    background-color: transparent;
                }
            }

            >button:nth-of-type(2){
                cursor: default;

                >span{
                    color: ${theme.colors.gray.Cinza_2};
                    font-weight: 700;
                    font-size: 0.875rem; 
                    line-height: 1.3125rem;
                    font-family: "Lato", Sans-serif;

                    text-transform: capitalize;
                }

                :hover{
                    background-color: transparent;
                }
            }

            >button:nth-of-type(3){
                :hover{
                    background-color: transparent;
                }
            }
        }

        >div:nth-last-child(1){
            >div>div{
                >button{
                    padding: 1.05rem 0; 
                }
                
                >div{
                    >div:nth-of-type(1){
                        justify-content: center;

                        >div>abbr{
                            text-decoration: none;
                        }
                    }
                }

                >div>div:nth-of-type(2) {
                    justify-content: center;
                    margin-top: 0.5rem;
                    >button{
                        width: 2.5rem;
                        height: 1.625rem;

                        display: flex;
                        margin-bottom: 0.5rem;
                        align-items: center;
                        justify-content: center;
                    } 
                }
            }
        }

        >div>div>div>div{
            >div:nth-of-type(1) {
               >div{
                width: 42.5px;
                padding: 0 0.2rem;
                flex: none !important;

                    @media (max-width: 375px) {
                        width: 36.5px;
                    }
                }
            }

            >div:nth-of-type(2) {
                >button{
                    padding: 0 0.2rem;
                    flex: none !important;
                    width: 42.5px !important;

                    @media (max-width: 375px) {
                        width: 36.5px !important;
                    }
                }
            }
        }

        @media (max-width: 900px) {
            width: 100%;
        }
    }

    @media (max-width: 1320px) {
        width: 100%;
        max-width: 100%;
    }

    @media (max-width: 900px) {
        min-width: auto;
        min-height: auto;

        align-items: center;
    }
`;

export const FarmWrapper = styled.div`
    width: auto;
    padding: 0.5rem;
    
    gap: 12px;
    display: flex;
    margin-bottom: 1rem;
    
    border-radius: 1rem;
    justify-content: center;
    border: 1px solid black;

    background-size: 1.25rem;
    background-color: transparent;
    background-repeat: no-repeat;
    background-image: url(${ArrowDown});
    background-position: right 1.188rem center;

    @media (max-width: 768px) {
        width: 90%;
    }

    @media (max-width: 360px) {
        width: 280px;
    }
`;

export const Lyrics = styled.div`
    width: 100%;
    max-width: 202px;

    flex-direction: column;

    >p{
        text-align: center;
    }
`;

export const FarmSelector = styled.button`
    all: unset;
    cursor: pointer;
    transition: 0.4s;

    display: flex;
    align-items: center;
    justify-content: center;

    position: relative;

    >img{
        width: 20px;
        height: auto;
    }

    select{
        all: unset;
        
        opacity: 0;
        height: auto;
        left: -15.6875rem;
        padding-left: 1rem;
        position: absolute;
        width: 17rem;

        color: ${theme.colors.gray.Cinza_2};
        font-weight: 800;
        font-size: 0.625rem;
        font-family: "Lato";
        line-height: 1.375rem;
        letter-spacing: 0.1rem;
        text-transform: uppercase;

        cursor: pointer;
        
        option{
            padding: 1rem;
            opacity: 1;
        }
    }

    @media (max-width: 360px) {
        margin-right: 1rem;
    }
`;

export const Preview = styled.div`
    width: 100%;
    height: 144px;
    padding: 12px 0;

    gap: 0.5rem;
    display: flex;
    align-items: center;
    justify-content: center;

    border-radius: 8px;
    background-color:#FFFFFF;
`;

export const Preview1 = styled.div`
    width: auto;
    height: auto;

    gap: 1rem;
    display: flex;
    flex-direction: column;
    align-items: ${({ weather }) => weather !== null ? "flex-end" : "center"};

    >img{
        width: 100%;
        height: auto;
        max-width: 80px;
    }
`;

export const Preview2 = styled(Preview1)`
   align-items: flex-start;
`;

export const MinTemperature = styled.div`
    width: auto;
    height: auto;

    gap: 8px;
    display: flex;
    align-items: center;

    >img{
        width: 16px;
        height: 16px;
    }

    >p{
        letter-spacing: 0.1em;

        @media (max-width: 375px) {
            font-size: 8px;
            line-height: 15px;
        }
    }
`;

export const AccuracyUpdates = styled.div`
    display: flex;
    margin-top: 1rem;
    align-items: center;
    flex-direction: column;
    justify-content: center;

    @media (max-width: 1310px) {
        margin: 0;
    }
`;

export const MaxTemperature = styled(MinTemperature)``;

export const ProbabilityRain = styled(MinTemperature)``;

export const PrecipitationRain = styled(MinTemperature)``;

export const Humidity = styled(MinTemperature)``;

export const Wind = styled(MinTemperature)``;

export const WeekContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const DayWrapper = styled.div`
  gap: 0.3rem;
  display: flex;
  align-items: center;
  flex-direction: column;
`;

export const WeekDay = styled.span`
  font-weight: 800;
  font-size: 11px;
  color: ${theme.colors.gray.Cinza_2};
  margin-bottom: 2px;
`;

export const DayNumber = styled.span`
  width: 2.625rem;
  height: 1.625rem;

  display: flex;
  
  cursor: pointer;
  font-size: 14px;
  font-weight: 400;
  align-items: center;
  justify-content: center;
  border-radius: 62.4375rem;

  color: ${({ isToday, isSelected }) =>
        isSelected ? "#FFF" : isToday ? `${theme.colors.blue.Azul_link}` : "#333"};

  background-color: ${({ isToday, isSelected }) =>
        isSelected ? "#000" : isToday ? "transparent" : "transparent"};

  ${({ isToday, isSelected }) =>
        isToday && isSelected &&
        `
    background-color: #589BFF;
    color: #FFF;
  `}

  &:hover {
    background-color: #ddd;
  }

  @media (max-width: 900px) {
    width: 2rem;
    height: 1.625rem;
  }
`;